import { CardType } from './constant';

export const isTypeOfDiscover = (cardType: string): boolean => {
  return [
    CardType.DISCOVER,
    CardType.JCB,
    CardType.DINERS,
    CardType.CUP,
  ].includes(cardType);
};

export const isTypeOfMasterCard = (cardType: string): boolean => {
  return [CardType.MASTERCARD, CardType.MAESTRO].includes(cardType);
};

export const isTypeOfVisa = (cardType: string): boolean => {
  return cardType.includes(CardType.VISA);
};

export const isTypeOfAmericanExpress = (cardType: string): boolean => {
  return cardType.includes(CardType.AMERICAN);
};
